import { useHistorySearch } from '@eagle/react-common';
import { FC, useEffect, useMemo } from 'react';
import { getThingRangeMapEvents } from '../trip-history-base-view-utils';
import { ThingRangeMapStateProps } from '../trip-history-base-view.types';

export const ThingRangeMapState: FC<ThingRangeMapStateProps> = ({ events, isActive, journeyId, selectedEntityId, showLocationUpdates, thingColor }) => {
  const { eventData, setEventData } = useHistorySearch();
  const mapEvents = useMemo(() => getThingRangeMapEvents(events, showLocationUpdates), [events, showLocationUpdates]);

  useEffect(() => {
    if (!isActive) {
      if (!eventData.some((item) => item.journeyId === journeyId)) return;
      setEventData(eventData.filter((item) => item.journeyId !== journeyId));
      return;
    }

    const currentItem = eventData.find((item) => item.journeyId === journeyId);
    const currentEventIds = currentItem?.data.items.map((event) => event.eventId).join('|') ?? '';
    const nextEventIds = mapEvents.map((event) => event.eventId).join('|');
    const currentForceVisible = 'forceVisible' in (currentItem ?? {}) ? (currentItem as { forceVisible?: boolean }).forceVisible : undefined;

    if (
      currentItem
      && currentItem.entityId === selectedEntityId
      && currentItem.entityDisplay === selectedEntityId
      && currentItem.color === thingColor
      && currentItem.isSelected === true
      && currentItem.showLocationUpdates === showLocationUpdates
      && currentForceVisible === true
      && currentEventIds === nextEventIds
    ) {
      return;
    }

    const nextItem = {
      color: thingColor,
      data: {
        count: mapEvents.length,
        hasMore: false,
        items: mapEvents,
      },
      entityDisplay: selectedEntityId,
      entityId: selectedEntityId,
      focused: true,
      forceVisible: true,
      isSelected: true,
      journeyId,
      showLocationUpdates,
    };

    const nextEventData = [
      ...eventData.filter((item) => item.journeyId !== journeyId),
      nextItem,
    ].map((item) => ({
      ...item,
      isSelected: item.journeyId === journeyId ? true : item.isSelected,
    }));

    setEventData(nextEventData);
  }, [eventData, isActive, journeyId, mapEvents, selectedEntityId, setEventData, showLocationUpdates, thingColor]);

  return <></>;
};

